import { ArrowSquareLeftOutlineIcon } from '@/components/Icons';
import classes from './ArrowButton.module.css'

interface Props {
    type: 'left' | 'right';
    onClick?: () => void;
    className?: string;
}

const ArrowButton = ({
    type,
    onClick,
    className
}: Props) => {
    const classNames = [classes.ArrowButton, className, classes[type]];

    return (
        <button className={classNames.join(' ')} onClick={onClick}>
            <ArrowSquareLeftOutlineIcon className={classes.icon} />
        </button>
    )
}

export default ArrowButton